import TotalsInServiceSummary from '../TotalsInServiceSummary/TotalsInServiceSummary';
import QuoteStatusInServiceSummary from '../QuoteStatusInServiceSummary/QuoteStatusInServiceSummary';
import { ITotalsServiceSummary } from 'components/SummaryBanner/SummaryBanner.types';
import { CURRENCIES } from 'types/bussines';
import './ApprovedQuote.scss';

interface IApprovedQuoteProps {
  quoteLink?: string;
  totals?: ITotalsServiceSummary;
  isManualQuote?: boolean;
}

const ApprovedQuote = ({
  totals = { totalUSD: 0, total: 0, currency: CURRENCIES.USD },
  ...rest
}: IApprovedQuoteProps) => {
  return (
    <div className="serviceSummaryBanner approvedQuote">
      <TotalsInServiceSummary totals={totals} />
      <QuoteStatusInServiceSummary variant="approved" {...rest} />
    </div>
  );
};

export default ApprovedQuote;
